export const getAWSConfig = (awsCredentials = null) => {
  const config = {
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1'
  };

  console.log('AWS Configuration Initialization:');
  console.log('- Region:', config.region);

  if (awsCredentials) {
    console.log('- Using Cognito credentials for authentication');
    config.credentials = awsCredentials;
  } else if (process.env.REACT_APP_AWS_ACCESS_KEY_ID && process.env.REACT_APP_AWS_SECRET_ACCESS_KEY) {
    console.log('- Using environment variables for credentials');
    console.log('- Access Key ID:', process.env.REACT_APP_AWS_ACCESS_KEY_ID ? `${process.env.REACT_APP_AWS_ACCESS_KEY_ID.substring(0, 8)}...` : 'not set');
    console.log('- Secret Key:', process.env.REACT_APP_AWS_SECRET_ACCESS_KEY ? 'set (hidden)' : 'not set');

    config.credentials = {
      accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
    };
  } else {
    console.log('- No credentials provided yet - will use Cognito after login');
    // Don't throw error here, let services handle it
  }

  return config;
};